import { useRef, useEffect, useState } from "react";
import { motion } from "motion/react";

export default function BlurText({
  text = "",
  className = "",
  delay = 200,
  direction = "bottom",
}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  const words = text.split(" ");

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const getInitial = () => {
    switch (direction) {
      case "top":
        return { filter: "blur(10px)", opacity: 0, y: -50 };
      case "left":
        return { filter: "blur(10px)", opacity: 0, x: -50 };
      case "right":
        return { filter: "blur(10px)", opacity: 0, x: 50 };
      default:
        return { filter: "blur(10px)", opacity: 0, y: 50 };
    }
  };

  return (
    <p ref={ref} className={`flex flex-wrap ${className}`} data-testid="blur-text">
      {words.map((word, i) => (
        <motion.span
          key={i}
          initial={getInitial()}
          animate={
            inView
              ? { filter: "blur(0px)", opacity: 1, y: 0, x: 0 }
              : getInitial()
          }
          transition={{
            duration: 0.5,
            delay: i * (delay / 1000),
            ease: "easeOut",
          }}
          className="inline-block mr-[0.3em]"
        >
          {word}
        </motion.span>
      ))}
    </p>
  );
}
